import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useSession } from '../../context/SessionContext';
import api from '../../services/api';
import Alert from '../Common/Alert';

const normalizeSessionUser = (rawUser) => {
  if (!rawUser || typeof rawUser !== 'object') return rawUser;
  const profileCode = (
    rawUser.profileCode
    || rawUser.ProfileCode
    || rawUser.profile
    || rawUser.Profile
    || rawUser.vUserTypeCode
    || rawUser.role
    || rawUser.Role
    || ''
  ).toString().trim();
  const profileDescription = (
    rawUser.profileDescription
    || rawUser.ProfileDescription
    || rawUser.vProfileDescription
    || ''
  ).toString().trim();
  return { ...rawUser, profileCode, profileDescription };
};

const ByPassLogin = () => {
  const navigate = useNavigate();
  const { setUser, setSessionProject } = useContext(AuthContext);
  const { initializeAuditValues } = useSession();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const doBypass = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.post('/Auth/BypassLogin');
      const userData = res.data?.user;
      if (!userData) {
        setError('Bypass login did not return user');
        return;
      }
      setUser(normalizeSessionUser(userData));
      if (res.data?.project) setSessionProject(res.data.project);
      const mappingId = res.data?.recordedByMappingId;
      initializeAuditValues(mappingId != null && mappingId !== undefined ? { nRecordedBy: mappingId } : {});
      setToast({ type: 'success', message: 'Login successful.' });
      setTimeout(() => navigate('/dashboard', { replace: true }), 1200);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to set session');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {toast && (
        <div style={{ position: 'fixed', top: 16, right: 16, zIndex: 10000 }}>
          <Alert type={toast.type} message={toast.message} onClose={() => setToast(null)} />
        </div>
      )}
      <div className="login-card">
        <h2>Bypass Login</h2>
        {error ? (
          <Alert type="error" message={error} />
        ) : (
          <>
            <p>Signing you in as bypass user</p>
            <button className="btn btn-primary" type="button" onClick={doBypass} disabled={loading}>
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ByPassLogin;
